import React, { useContext, useEffect, useState, useRef, createRef } from "react";
import { Box, Collapse, Badge, Heading, Text, Icon, Link, Flex, Skeleton } from "@chakra-ui/core";
import { ContextStore } from "context/ContextStore";
import CalendarOutline from "svg/icons/calendar.svg";
import LocationMarkerOutline from "svg/icons/location-marker.svg";
import ClockOutline from "svg/icons/clock.svg";
import PhoneOutline from "svg/icons/phone.svg";

const Banner = () => {
  const { today, ouvert, openingHours, waitingTime, isStoreManuallyClosed, isDashboardOnline, isOpeningTime } =
    useContext(ContextStore);

  const [showOpeningHours, setShowOpeningHours] = useState(false);

  const handleToggle = () => setShowOpeningHours(!showOpeningHours);

  const defaultBadgeText = "Commandes acceptées";
  const defaultBadgeColor = "green";

  const [badgeText, setBadgeText] = useState(defaultBadgeText);
  const [badgeColor, setBadgeColor] = useState(defaultBadgeColor);

  useEffect(() => {
    if (!isOpeningTime) {
      setBadgeText("Fermé (horaires)");
      setBadgeColor("red");
      return;
    } else if (isStoreManuallyClosed) {
      setBadgeText("Commandes refusées");
      setBadgeColor("red");
      return;
    } else if (!isDashboardOnline) {
      setBadgeText("Indisponible temp.");
      setBadgeColor("orange");
      return;
    } else {
      setBadgeText(defaultBadgeText);
      setBadgeColor(defaultBadgeColor);
    }
  }, [isOpeningTime, isStoreManuallyClosed, isDashboardOnline]);

  return (
    <>
      <Box
        // mt='16'
        bgImage={"url(/images/banner-bg.jpg)"}
        bgPos="center"
        bgSize="cover"
        bgRepeat="no-repeat"
      >
        <Box bg="rgba(0,0,0,0.4)">
          <Box maxW="7xl" mx="auto" px={{ base: "4", sm: "6", lg: "8" }} overflow="hidden">
            <Box
              border="1px"
              borderColor="gray.200"
              p="6"
              my="16"
              bg="white"
              display="inline-block"
              rounded="lg"
              shadow="lg"
            >
              <Heading size="lg">Commander à La Citadelle</Heading>
              {ouvert !== undefined ? (
                <Flex align="center" justify="flex-start">
                  <Badge variantColor={badgeColor} fontSize="sm">
                    {badgeText}
                  </Badge>
                  <Box ml={2}>
                    <Box
                      borderWidth="2px"
                      borderColor={isDashboardOnline ? "green.200" : "orange.200"}
                      h={1}
                      w={1}
                      rounded="full"
                    />
                  </Box>
                </Flex>
              ) : (
                <Skeleton h="17px" w="250px" display="inline-block" />
              )}
              <Text py="2" fontSize="sm">
                Pizza • Burger • Sandwich • Tex Mex • Street Food • Fast food
              </Text>
              <Flex align="center" justify="flex-start" pb="2">
                <Icon name="star" size="13px" mr="1" color="yellow.300" />
                <Icon name="star" size="13px" mr="1" color="yellow.300" />
                <Icon name="star" size="13px" mr="1" color="yellow.300" />
                <Icon name="star" size="13px" mr="1" color="yellow.300" />
                <Icon name="star" size="13px" mr="2" color="gray.300" />
                <Box as="span" fontWeight="semibold" fontSize="sm">
                  4.1{" "}
                  <Box as="span" fontWeight="bold">
                    (
                    <Link href="https://search.google.com/local/reviews?placeid=ChIJVQby6eDp9EcRSfkkzedXUVM" isExternal>
                      340 avis
                    </Link>
                    )
                  </Box>
                </Box>
              </Flex>
              {waitingTime ? (
                <Text pb="2" fontSize="sm">
                  <Box as={ClockOutline} size="14px" mr="2" color="gray.700" mt="-2px" display="inline-block" />
                  Retrait sur place dans {waitingTime} min
                </Text>
              ) : (
                <Skeleton h="21px" w="full" mb="2" />
              )}
              {today ? (
                <>
                  <Text pb="2" fontSize="sm" onClick={handleToggle} cursor="pointer">
                    <Box as={CalendarOutline} size="14px" mr="2" color="gray.700" mt="-2px" display="inline-block" />
                    Commandez le {today.day} de {today.openAM}
                    {today.openAM && today.closeAM && " à "}
                    {today.closeAM}
                    {today.closeAM && today.openPM && " et "} {today.openPM}
                    {today.openPM && today.closePM && " à "}
                    {today.closePM}
                    <Icon
                      name={showOpeningHours ? "chevron-up" : "chevron-down"}
                      size="16px"
                      ml="1"
                      color="gray.700"
                      mt="-2px"
                    />
                  </Text>
                  <Collapse pb={2} isOpen={showOpeningHours}>
                    <Box as="table">
                      <Box as="tbody">
                        {openingHours &&
                          openingHours.map((openingHour, i) => {
                            return (
                              <Box as="tr" key={i}>
                                <Text as="td" fontSize="sm" pr="4">
                                  {openingHour.day}
                                </Text>
                                <Text as="td" fontSize="sm">
                                  {openingHour.openAM}
                                  {openingHour.openAM && openingHour.closeAM && " à "}
                                  {openingHour.closeAM}
                                  {openingHour.closeAM && openingHour.openPM && " et "} {openingHour.openPM}
                                  {openingHour.openPM && openingHour.closePM && " à "}
                                  {openingHour.closePM}
                                </Text>
                              </Box>
                            );
                          })}
                      </Box>
                    </Box>
                  </Collapse>
                </>
              ) : (
                <Skeleton h="21px" w="full" mb="2" />
              )}
              <Text fontSize="sm" mb={2}>
                <Box as={LocationMarkerOutline} size="14px" mr="2" color="gray.700" mt="-2px" display="inline-block" />6
                Avenue Albert Thomas, Saint-Fons, 69190
              </Text>
              <a href="tel:+33478674551">
                <Text fontSize="sm">
                  <Box as={PhoneOutline} size="14px" mr="2" color="gray.700" mt="-2px" display="inline-block" />
                  04 78 67 45 51
                </Text>
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Banner;
